export * as handsSign from './hands-background.png'
export * as phone from './phone.png'
export * as avatar1 from './Avatar1.png'
export * as avatar2 from './Avatar2.png'
